import type { RequestContext, Client } from "../client";
import type { LicensedFeature } from "./licensedFeatures";
// See "Enterprise Feature Request Mapping" lookup table in Workato.
type FeatureAvailableForTrial = Extract<LicensedFeature, "GlobalDeploymentFreeze" | "PriorityTask">;
interface RequestFeatureTrialCommand {
    TypeOfFeature: FeatureAvailableForTrial;
}
export async function requestFeatureTrial(command: RequestFeatureTrialCommand, client: Client, requestContext: RequestContext): Promise<void> {
    return await client.post(requestContext, "~/bff/featuretrial/request-trial", command);
}
